
export {Popover} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$popover.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$popover.js';export default __x__;